import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import SubMenuView from '../../views/subMenuView';
import Language from './language';
import TimeDate from './time-date';

function LoadConfig() {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <Language />},
    {id: 2, name: 'No', component: <TimeDate />},
  ];
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent, selected, setSelected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    // setSelected(selected);
    // onComponent(<Language />);
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  return (
    <SubMenuView
      title="Set Rotation"
      menuItems={yesNoItem}
      content="Do you want to rotate the screen?"
      onLeftCallback={() => onComponent(<Language />)}
    />
  );
}
export default LoadConfig;
